export default __webpack_public_path__ + "static/media/404.13756e3a.png";